var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var width = "57.7%";
var height = "6.4%";
var left = "21.7%";
var isExternal = true;
var iniTop = 9.6;
var padding = 6.6;
var urlgen = function (name) { return name.toLocaleLowerCase()
    .replace("&", "")
    .replace(/deepfakes/ig, "deep-fakes")
    .replace(/biometric/ig, "bio-metric")
    .replace(/analyst podcast\:\s/gi, "")
    .replace(/\s|\,|\:/g, "-"); };
var url = "https://www.securityforum.org/spotlight-on/";
var equalLink = [
    "The impact of the persistent CISO",
    "The race for tech dominance",
    "Organised crime goes digital",
    "Keeping the M&A process secure",
    "Deepfakes and biometric security breakthroughs",
    ["Beyond buzz words: AI, ML and the future of cyber", "https://www.securityforum.org/spotlight-on/beyond-buzz-words-ai--ml-and-the-future-of-cyber/"],
    "Reserving the CISOs seat at the table",
    "Protecting IP in a world of streaming and sharing",
    "The cost of the FUD approach to security",
    "How global law enforcements fight cybercrime",
    "Analyst Podcast: Getting smart about Threats",
    "Analyst Podcast: Roles and rewards: How the role of the CISO is changing",
    "Analyst Podcast: Lessons Learned: How CISOs must change their strategy to survive"
];
var links = __spreadArray([], equalLink.map(function (label) { return Array.isArray(label) ? {
    label: label[0],
    href: label[1]
} : {
    label: label,
    href: "".concat(url).concat(urlgen(label))
}; }), true).map(function (cur, idx) {
    return __assign(__assign({ width: width, height: height, left: left, isExternal: isExternal, top: "".concat(iniTop + (padding * idx), "%") }, cur), { target: "_blank" });
});
links.push({
    label: "ISF Podcast fact sheet 2022",
    href: "https://assets.swoogo.com/uploads/2138821-6350185c87cf6.pdf",
    width: "19.7%",
    height: "4.4%",
    left: "59.7%",
    top: "3.8%",
    isExternal: true,
    target: "_blank"
});
export default links;
